<template>
  <div v-if="visible" class="custom-loader">
    <div class="custom-loader-wrap">
      <div class="custom-loader-wrap_text" :data-text="text"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MLoading',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: 'Weelife'
    }
  },
  setup() {
    return {}
  }
})
</script>

<style lang="scss" scoped>
.custom-loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
}

.custom-loader-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 12%;
}

.custom-loader-wrap_text {
  width: fit-content;
  font-weight: bold;
  font-family: monospace;
  font-size: 48px;
  background: radial-gradient(circle closest-side, #000 94%, #0000) right/calc(200% - 16px) 100%;
  animation: l24 1s infinite alternate linear;
}

.custom-loader-wrap_text::before {
  content: attr(data-text);
  line-height: 32px;
  color: #0000;
  background: inherit;
  background-image: radial-gradient(circle closest-side, #fff 94%, #000);
  -webkit-background-clip: text;
  background-clip: text;
}

@keyframes l24 {
  100% {
    background-position: left;
  }
}
</style>
